// App constants; if needed, may be moved to .env file in repository top level
export var PIGMENT_CDN_URL = 'https://pigment-cdn.customink.com';
//# sourceMappingURL=config.js.map